export default () => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    gridColumnGap: 16,
    justifyContent: 'flex-end',
    marginTop: 48,
    alignItems: 'center',
});
